"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CinTinFields = CinTinFields;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const types_1 = require("@src/types");
function CinTinFields({ intl, rules }) {
    const { cinRules, tinRules, tinVatRules } = rules;
    return ((0, jsx_runtime_1.jsxs)(antd_1.Col, { xs: 24, md: 12, children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                    id: 'admin.company_info_edit_form.cin',
                }), name: types_1.CompanyInfoEditFormField.cin, rules: cinRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input, {}) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                    id: 'admin.company_info_edit_form.tin',
                }), name: types_1.CompanyInfoEditFormField.tin, rules: tinRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input, {}) }), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                    id: 'admin.company_info_edit_form.tin_vat',
                }), name: types_1.CompanyInfoEditFormField.tin_vat, rules: tinVatRules, children: (0, jsx_runtime_1.jsx)(antd_1.Input, {}) })] }));
}
